/**
 * Route-level feed-need fallback (consumer feed filters, Phase 2).
 *
 * The Phase-2 `sports` allow-list is built from what mounted sources declare
 * they render. Only the Value Dashboard declares a narrow set today; every
 * other route — game detail, positions, trades, research, bots — may need any
 * sport, and must not be starved by the dashboard's declaration lingering in
 * a sibling tab. So this component declares `sports: 'all'` for every path
 * the dashboard does not own. Inert (declares nothing worth sending) unless
 * VITE_FEED_FILTERS_SPORTS is on; class/type opt-ins are unaffected.
 */
import { useLocation } from 'react-router';
import { useFeedNeeds } from '@/hooks/useFeedNeeds';

const SPORT_SCOPED_PREFIXES = ['/dashboard'];

export function FeedNeedsRouteFallback() {
  const { pathname } = useLocation();
  const scoped = SPORT_SCOPED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  useFeedNeeds('route', scoped ? null : { sports: 'all' });
  return null;
}
